import React from 'react'

/**
 * Reusable component for attachment viewer controls (zoom in, zoom out, close)
 * @param {object} props
 * @param {boolean} props.isImage - Whether the current attachment is an image
 * @param {boolean} [props.canZoomIn=true] - When false, + button is disabled (like WhatsApp at max zoom)
 * @param {boolean} [props.canZoomOut=true] - When false, − button is disabled (like WhatsApp at 1x)
 * @param {function} props.onZoomIn - Handler for zoom in button
 * @param {function} props.onZoomOut - Handler for zoom out button
 * @param {function} props.onClose - Handler for close button
 */
const AttachmentViewerControls = ({ isImage, canZoomIn = true, canZoomOut = true, onZoomIn, onZoomOut, onClose }) => (
  <div className="attachment-viewer-controls">
    {isImage && (
      <>
        <button type="button" disabled={!canZoomOut} onClick={onZoomOut} aria-label="Zoom out" className="viewer-control-btn zoom-out-btn">
          −
        </button>
        <button type="button" disabled={!canZoomIn} onClick={onZoomIn} aria-label="Zoom in" className="viewer-control-btn zoom-in-btn">
          +
        </button>
      </>
    )}
    <button onClick={onClose} aria-label="Close" className="viewer-control-btn close-btn">
      ✕
    </button>
  </div>
)

export default AttachmentViewerControls
